/* <pdp-email-button>: product page 'email_button' block. Liquid renders the full mailto: href for the first paint; this
   element rebuilds the option lines after each variant change (pdp2:variant, or the picker's own VARIANT_CHANGE outside
   pdp2) and appends them to data-href-base. Values are read per option container, so a combination without a variant
   still lists what the customer chose and an unchosen option (variant required) is skipped. */
if (!customElements.get('pdp-email-button')) {
  class PdpEmailButton extends HTMLElement {
    connectedCallback() {
      this._link = this.querySelector('.pdp-email-button__link');
      try {
        this._names = JSON.parse(this.dataset.optionNames || '[]');
      } catch (e) {
        this._names = [];
      }
      if (!this._link || !this._names.length) return;

      // Scoped to the block's own section so foreign pickers elsewhere on the page are never read.
      this._root = this.closest('pdp2-section');
      const scope = this._root || this.closest('.shopify-section');
      this._picker = scope ? scope.querySelector('product-variants[data-main-product-variants]') : null;
      if (!this._picker) return;

      if (!this._onChange) this._onChange = (e) => this._apply((e.detail && e.detail.picker) || e.target);
      if (this._root) {
        this._root.addEventListener('pdp2:variant', this._onChange);
      } else {
        this._picker.addEventListener('VARIANT_CHANGE', this._onChange);
      }
      this._apply(this._picker);
    }

    disconnectedCallback() {
      if (!this._onChange) return;
      if (this._root) this._root.removeEventListener('pdp2:variant', this._onChange);
      if (this._picker) this._picker.removeEventListener('VARIANT_CHANGE', this._onChange);
    }

    _apply(picker) {
      const containers = picker.querySelectorAll('[data-js-product-variant-container]');
      const lines = [];
      this._names.forEach((name, index) => {
        const container = containers[index];
        if (!container) return;
        let value = '';
        if (container.dataset.jsProductVariantContainer === 'radio') {
          const input = container.querySelector('.product-variant__input:checked');
          if (input) value = input.value;
        } else if (!(picker.variantRequired && container.selectedIndex === 0)) {
          value = container.value;
        }
        if (value) lines.push(name + ': ' + value);
      });
      const options = lines.length ? encodeURIComponent('\r\n' + lines.join('\r\n')) : '';
      this._link.href = this.dataset.hrefBase + options;
    }
  }

  customElements.define('pdp-email-button', PdpEmailButton);
}
